import React from 'react';
import type { Event } from '@/types/event';
import { X, ChevronLeft } from 'lucide-react';
import { Button } from '../basic/Button';

interface ModalHeaderProps {
  event: Event;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ event, onClose }) => {
  return (
    <div className="flex justify-between px-3 sm:px-4 md:px-5 pt-3 sm:pt-4 md:pt-5">
      <Button
        onClick={onClose}
        variant="ghost"
        size="sm"
        icon={ChevronLeft}
        iconPosition="left"
        className="bg-black/30 hover:bg-black/60 text-xs sm:text-sm"
      >
        Back
      </Button>

      <Button
        onClick={onClose}
        variant="ghost"
        size="sm"
        className="p-1 sm:p-2"
        aria-label="Close modal"
      >
        <X size={16} className="sm:w-4 sm:h-4 text-white" />
      </Button>
    </div>
  );
};

export default ModalHeader;